import styled from 'styled-components';

export const WrapperProjectInfo = styled.div`
  align-self: center;

  .project-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.43;
    color: #000000;
    padding-right: 10px;
  }
`;

export const WrapperProgressBar = styled.div`
  margin: 0 0 0.5rem 0;

  .progress {
    border-radius: 0;
    height: 10px;
    background-color: #e8e9e6 !important;

    .progress-bar {
      background-color: #ff0000;
    }
  }
`;

export const WrapperModal = styled.div`
  order: 2;

  .customClose {
    background-color: #ffffff;
    position: absolute;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    top: -7px;
    right: -7px;
    line-height: normal;
  }
`;

export const Section = styled.section`
  background: ${({ actionView }) => (actionView ? '#ffffff' : '#f7f7f7')};
`;

export const Wrapper = styled.div`
  .myspan {
    font-size: 48px;
  }

  .form-control {
    &::placeholder {
      color: #999;
    }
  }
  .search-param {
    color: #85ac20;
  }

  .spinner-container {
    height: 158px;

    .spinner-border {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -0.625em;
      margin-left: -0.625em;
      color: #ff0000 !important;
    }
  }

  input {
    height: 40px;
    &:focus {
      border-color: #777;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(119, 119, 119, 0.6);
      outline: 0;
      /* border-color: #ff0000;
		box-shadow: 0 0 0 0.2rem #ff000038; */
    }
  }

  .activeFilter {
    white-space: nowrap;
    background-color: #ffffff;
    margin: -29px 15px 30px 15px;
    padding: 15px 30px 15px 30px;
    overflow-x: auto;

    .search-param {
      color: #85ac20;
    }

    span {
      letter-spacing: 0.28px;
      color: #ff0000;
      font-size: 14px;
    }

    .filter-zip {
      cursor: pointer;
      color: #505050;
      margin: 0 0 0 10px;
      padding: 6px 10px;
      background-color: #e8e8e5;

      :hover {
        .filter-zip-button {
          color: #ff0000;
        }
      }
    }

    .filter-zip-button {
      color: #9b9b9b;
      margin: 0 10px 0 0;
    }
  }

  .project-form {
    background-color: #ffffff;
    margin: 10px 15px 30px 15px;
    padding: 30px 30px 22px 30px;

    input,
    button {
      border-radius: 0;
      font-size: 14px;
    }

    button {
      white-space: nowrap;
      background-color: #ff0000;
      padding: 6px 24px;
      font-family: Sparkasse-Ligher;
      text-shadow: 0 0 1px #ffffff;
      font-size: 14px;
      color: #ffffff;

      &:hover,
      &:active {
        background-color: #c00;
        border-color: #c20000;
        box-shadow: 0 0 0 0;
      }

      &:focus {
        background-color: #c00;
        border-color: #800000;
        outline: 5px auto black;
        outline-offset: -2px;
        box-shadow: 0 0 0 0;
      }

      &:focus:hover:active {
        background-color: #a80000;
        border-color: #800000;
        box-shadow: 0 0 0 0;
      }
    }
  }

  .project-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.43;
    color: #000000;
  }

  .hr {
    opacity: 0.5;
    margin: 10px 0 8px 0;
    background-color: #979797 !important;
    height: 1px;
  }

  .project-card {
    height: 362px;

    div.row {
      border: solid 1px #ced4da;
    }

    div {
      cursor: pointer;
      img {
        width: 100%;
        height: 158px;
        object-fit: cover;
        object-position: center;
      }

      .image-poster {
    		background-size: cover;
    		height: 168px;
    		width: 100%;
    		margin-bottom: 1rem;
  			background-repeat: no-repeat;
  			background-position: 50% 50%;
    }

      div {
        background: #ffffff;
      }
    }
  }

  h5 {
    font-family: Sparkasse-Bolder;
    font-size: 21px;
  }

  h3 {
    line-height: 1.43;
    font-size: 18px;
  }

  button {
    height: 40px;
  }

  #button-showmore {
    background: #000000;
    border-radius: 0;

    &:hover,
    &:active {
      background-color: #1d2124;
      border-color: #464646;
      box-shadow: 0 0 0 0;
    }

    &:focus {
      background-color: #464646;
      border-color: #464646;
      box-shadow: 0 0 0 0;
      outline: 5px auto #505050;
      outline-offset: -2px;
    }

    :focus:active {
      background-color: #565656;
      border-color: #565656;
      box-shadow: 0 0 0 0;
    }

    span {
      font-family: Sparkasse-Ligher;
      text-shadow: 0 0 1px #ffffff;
      font-size: 14px;
      color: #ffffff;
      padding: 0 24px;
      letter-spacing: 0.28px;
    }
  }
`;

export const WrapperCarrierName = styled.div`
  color: #808080;
  padding-top: 0.5rem;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const WrapperProjectTittle = styled.div`
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.25;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const WrapperModalHeader = styled.div`
  div {
    background: #ff0000;
    border-bottom: 0px;
  }

  .w60 {
  	max-width: 45%;
  	order: 3;
  }


  .w30 {
  	max-width: 45%;
  	order: 1;
  }

  .mrgTopBottom {
  	margin-top: 10px;
  	margin-bottom: 10px;
  }

  .branch__logo {
  	max-width: 100%;
  	height: 100px;
  }
`;

export const WrapperModalBodyTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

export const WrapperModalBodySummary = styled.div`
  /* display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center; */
  display: block;
  font-size: 14px;
  color: #808080;

  @media screen and (max-width: 992px) {
    span {
      font-size: 11px;
    }

    img {
      transform: scale(0.7);
    }
  }
`;

export const WrapperModalBodyDivider = styled.div`
  border-right: solid 1px #979797;
  opacity: 0.5;

  @media screen and (max-width: 992px) {
    width: 100%;
    border-top: solid 1px #979797;
    margin: 1rem 1rem;
  }
`;

export const WrapperModalBodyImage = styled.div`
  display: flex;
  align-items: center;
  height: 68px;
  width: 70px;
  padding: 0 3px;
  border: solid 1px #e8e9e6;
`;

export const WrapperModalCentralImage = styled.div`
  img {
    width: 100%;
    /* padding: 0 1rem 0 1rem; */

    @media screen and (max-width: 992px) {
      padding: 0 0 0 0;
    }
  }
`;

export const WrapperModalBottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  .left-block {
    width: 50%;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 992px) {
      width: 100%;
      justify-content: space-between;
    }
  }
`;

export const WrapperModalSocialButtons = styled.div`
  align-self: center;
  margin: 0 0 0 1rem;
  transform: scale(1.2);

  button {
    height: 40px;
  }

  button:focus {
    outline: 1px dashed red;
  }

  @media screen and (max-width: 992px) {
    margin: 0 1rem 0 0;
  }
`;

export const WrapperYMsuggest = styled.div`
  .awesomplete {
    width: 100%;

    ul {
      box-shadow: 0;
    }

    li {
      font-size: 18px;
      font-size: 1rem;
      padding: 0.5em 0.65em;
      line-height: 1.5rem;
      cursor: pointer;
    }
    li:hover,
    li:focus {
      color: #000;
      background: #f5f5f5;
    }
  }
  input {
    color: #495057;
    line-height: 1.7;
    width: 100%;
    border: 1px solid #ced4da;
    /* box-shadow: 0 0 1px #3d464d; */
    padding: 5px 1em;
    /* -webkit-transition: border 0.2s, box-shadow 0.2s; */
    /* transition: border 0.2s, box-shadow 0.2s; */
  }
  input:focus {
    border: 1px solid #ff0000;
    box-shadow: 0 0 0 0.2rem #ff000038;
    outline: 0;
  }

  .geosuggest__suggests {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 25em;
    padding: 0;
    margin-top: -1px;
    background: #fff;
    border: 1px solid #ff0000;
    border-top-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    list-style: none;
    z-index: 5;
    /* -webkit-transition: max-height 0.2s, border 0.2s; */
    /* transition: max-height 0.2s, border 0.2s; */
  }
  .geosuggest__suggests--hidden {
    max-height: 0;
    overflow: hidden;
    border-width: 0;
  }

  /**
 * A geosuggest item
 */

  .geosuggest__item--active {
    background: #267dc0;
    color: #fff;
  }
  .geosuggest__item--active:hover,
  .geosuggest__item--active:focus {
    background: #ccc;
  }
  .geosuggest__item__matched-text {
    font-weight: bold;
  }
`;

export const ClosedProjectBadge = styled.img`
  position: absolute;
  width: 84px !important;
  height: 32px !important;
  top: 2rem;
  left: 1rem;
`;

export const ClosedProjectBadgeModal = styled(ClosedProjectBadge)`
  top: 8rem;
  left: 0;
`;

export const AssociationTabsWrapper = styled.div`
  display: inline-flex;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  padding: 4px;
  margin: 0 15px 2rem 15px;
`;

export const AssociationTab = styled.button`
  padding: 8px 24px;
  border-radius: 6px;
  border: none;
  background: ${({ active }) => (active ? '#ff0000' : 'transparent')};
  font-family: Sparkasse-Ligher;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: ${({ active }) => (active ? '#ffffff' : '#6b7280')};
  letter-spacing: 0.28px;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ active }) => (active ? '#cc0000' : 'transparent')};
    color: ${({ active }) => (active ? '#ffffff' : '#111827')};
  }

  &:focus {
    outline: 2px solid #ff0000;
    outline-offset: 2px;
  }
`;
